module.exports = __webpack_public_path__ + "static/media/home-04.25d39f50.webm";